import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';
//ssss
export const getReconcillation = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/method/run_doc_method', body);
  return data;
});
export const addReconcillation = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/method/run_doc_method', body);
  return data;
});
